/* Bootstrap */

// import "bootstrap";
import { Accordion } from 'bootstrap'

/* Custom SCSS */
// import "./index.scss";
// import './style-login.scss';
// import './style-admin.scss';
// import './style-buttons.scss';

/* Swiper */

import Swiper, { Navigation, Pagination, Mousewheel, Autoplay } from "swiper";
import "swiper/css";
import 'swiper/css/navigation';
import 'swiper/css/pagination';
// import 'swiper/css/scrollbar';


$(window).on('load', function () {
  var slider_loghi = new Swiper(".slider_loghi", {
      slidesPerView: 2.5,
      spaceBetween: 20,
      breakpoints: {
          990: {
              slidesPerView: 8
          }
      }
  });

  var gallery_swiper = new Swiper(".gallery_swiper", {
      slidesPerView: 1.2,
      modules: [Navigation],
      spaceBetween: 15,
      navigation: {
          nextEl: ".button-next",
          prevEl: ".button-prev",
      },
      breakpoints: {
          990: {
              slidesPerView: 1.5        
          }
      }
  });

  if($('.slider_expertise').length && $('.slider_expertise').data('initial-slide')) {
      var initialSlide = parseInt($('.slider_expertise').data('initial-slide'));
  } else {
      var initialSlide = 0;
  }
  var slider_expertise = new Swiper(".slider_expertise", {
      modules: [Pagination, Mousewheel],
      initialSlide: initialSlide,
      pagination: {
          el: ".swiper-pagination",
          clickable: true,
      },
      breakpoints: {
          990: {
              allowTouchMove: false,
              direction: "vertical",
              mousewheel: false
          }
      },
      

  });



  /*
  document.querySelectorAll(".swiper.slider_expertise_interno").forEach((el) => {
    const next = el.querySelector(".button-next");
    const prev = el.querySelector(".button-prev");
    new Swiper(el, {
      modules: [Navigation, Pagination],
      navigation: {
          nextEl: next,
          prevEl: prev,
      },
      watchOverflow: false,
    });
  })*/

  var slider_swiper = new Swiper(".slider_swiper", {
      slidesPerView: 'auto',
      spaceBetween: 8,
      breakpoints: {
          990: {
              spaceBetween: 16
          }
      }
  });

  var slider_semplice = new Swiper(".slider_semplice", {
      slidesPerView: 'auto',
      modules: [Autoplay],
      spaceBetween: 16,
      autoplay: {
          delay: 2000,
          disableOnInteraction: false,
      }
      /*breakpoints: {
          990: {
              slidesPerView: 8
          }
      }*/
  });

  var slider_singolo = new Swiper(".slider_singolo", {
      slidesPerView: 1,
      modules: [Navigation],
      navigation: {
          nextEl: ".button-next",
          prevEl: ".button-prev",
      }
  });

  var slider_fotografi = new Swiper(".slider_fotografi", {
      slidesPerView: 1.5,
      spaceBetween: 8,
      breakpoints: {
          990: {
              slidesPerView: 2.5,
              spaceBetween: 16
          }
      }
  });

  let swiperInstance = null;

  function initSwiperIfMobile() {
    const breakpoint = 990;
    const isMobile = window.innerWidth <= breakpoint;

    if (isMobile && swiperInstance === null) {
      swiperInstance = new Swiper('.latest_posts', {
          wrapperClass: 'mobile-slider-wrapper',
          modules: [Pagination],
          slideClass: 'elemento_post',
          slidesPerView: 1,
          pagination: {
              el: '.swiper-pagination',
                  clickable: true,
              },
      });
    } else if (!isMobile && swiperInstance !== null) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }

  if($('.latest_posts').length) {
      initSwiperIfMobile();
      window.addEventListener('resize', initSwiperIfMobile);
  }

  if( $('.fascia_expertise').length && window.innerWidth > 990) {
  let currentSlide = $('.fascia_expertise').find('.slider_expertise').data('initial-slide') || 0;
  const totalSlides = slider_expertise.slides.length;

  let isInScrollZone = false;
  let scrollLocked = false;
  let swiperUnlocked = false;
  let unlockTimeout;

  function disablePageScroll() {
    document.body.style.overflow = 'hidden';
    $('.hamburger').css('right', 'calc(4vw + 15px)')
  }

  function enablePageScroll() {
    document.body.style.overflow = '';
    $('.hamburger').css('right', '4vw')
  }

  ScrollTrigger.create({
    trigger: '.fascia_expertise',
    start: 'top top',
    end: () => `+=${window.innerHeight}`,
    pin: true,
    scrub: false,
    onEnter: () => {
      isInScrollZone = true;
      swiperUnlocked = false;
      disablePageScroll();
      unlockTimeout = setTimeout(() => {
        swiperUnlocked = true;
      }, 800); // ritardo sblocco (puoi regolare)
    },
    onLeave: () => {
      isInScrollZone = false;
      enablePageScroll();
      clearTimeout(unlockTimeout);
    },
    onEnterBack: () => {
      isInScrollZone = true;
      swiperUnlocked = false;
      disablePageScroll();
      unlockTimeout = setTimeout(() => {
        swiperUnlocked = true;
      }, 800); // stesso ritardo anche da sotto
    },
    onLeaveBack: () => {
      isInScrollZone = false;
      enablePageScroll();
      clearTimeout(unlockTimeout);
    },
  });

  window.addEventListener('wheel', (e) => {
    if (!isInScrollZone || scrollLocked) return;

    e.preventDefault();

    if (!swiperUnlocked) {
      return; // blocca tutto finché non è sbloccato
    }

    const delta = e.deltaY;

    if (delta > 40) {
      scrollLocked = true;
if (currentSlide < totalSlides - 1) {
  scrollLocked = true;
  currentSlide++;
  slider_expertise.slideTo(currentSlide);
  setTimeout(() => scrollLocked = false, 500);
} else {
  // Ultima slide → sblocco immediato e bypasso il blocco scroll
  isInScrollZone = false;
  enablePageScroll();
  ScrollTrigger.getAll().forEach(t => t.enable());
  scrollLocked = false; // <--- sblocco immediato
}

      setTimeout(() => scrollLocked = false, 1000);
    } else if (delta < -40) {
      scrollLocked = true;
      if (currentSlide > 0) {
        currentSlide--;
        slider_expertise.slideTo(currentSlide);
      } else {
        isInScrollZone = false;
        enablePageScroll();
        ScrollTrigger.getAll().forEach(t => t.enable());
        window.scrollBy(0, -50);
      }
      setTimeout(() => scrollLocked = false, 1000);
    }
  }, { passive: false });
}

})





// Swiper.use([Scrollbar]);
// init Swiper:

// import swiperSlider from "./js/swiperSlider";
// swiperSlider();

/* Fancybox */

// import { Fancybox } from "@fancyapps/ui";
// import "@fancyapps/ui/dist/fancybox.css";

/* Gsap */

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";

gsap.registerPlugin(ScrollTrigger, SplitText, ScrambleTextPlugin);

const $hoverzoom = document.querySelectorAll('.hover_zoom');
const $bigCursor = document.querySelector('.cursor__ball--big');

document.addEventListener("DOMContentLoaded", () => {
  ScrollTrigger.create({
    trigger: '.fascia-values',
    start: 'top 80%',
    onEnter: () => {
      document.querySelectorAll('.fascia-values .titolo_pb').forEach((el) => {
        $(el).css('opacity', 1);
        const text = el.textContent.trim();
        gsap.to(el, 3, {
          scrambleText: {
            text: text,
            chars: "lowercase"
          }
        });
      });
    }
  });
})

// Listeners
if ($bigCursor) {
    gsap.set($bigCursor, { opacity: 0 });
    document.body.addEventListener('mousemove', onMouseMove);
    for (let i = 0; i < $hoverzoom.length; i++) {
    $hoverzoom[i].addEventListener('mouseenter', onMouseHover);
    $hoverzoom[i].addEventListener('mouseleave', onMouseHoverOut);
    }
}
function onMouseMove(e) {
  gsap.to($bigCursor, .4, {
    x: e.x - 15,
    y: e.y - 15,
  })
}
// Hover an element
function onMouseHover() {
  gsap.to($bigCursor, .3, {
    scale: 4,
    opacity: 1,
  })
}
function onMouseHoverOut() {
  gsap.to($bigCursor, .3, {
    scale: 1,
    opacity: 0
  })
}



const tlMenuOpen = gsap.timeline({paused: true, reversed: true});
tlMenuOpen
    .from(
        $('#menu-main-menu .menu-item'),
            { y: -70, opacity: 0, duration: .8, stagger: 0.06, delay:.5 }, 'animlogo'
        )
    .from(
        $('#navbarToggler .widget-sidebar'),
            { y: -70, opacity: 0, duration: .8, stagger: 0.2, delay: 1 }, 'animlogo'
        )


        


const navbarToggler = document.querySelector(".navbar-toggler");
if (navbarToggler) {
    navbarToggler.addEventListener("click", () => {
        navbarToggler.classList.toggle("collapsed");
        $("#navbarToggler").toggleClass("aperto");
        $("body").toggleClass("noscroll");

        if (tlMenuOpen.reversed()) {
            $('.navbar-toggler').removeClass('collapsed');
            tlMenuOpen.play();
        } else {
            $('.navbar-toggler').addClass('collapsed');
            tlMenuOpen.reverse();
        }
    });
}

$('#menu_text').on('click', function(e) {
    $(".navbar-toggler").click()
});


/* Flip cards */
const flipCardsCanHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

document.querySelectorAll('.flip_cards .flip_card').forEach((card) => {
    const inner = card.querySelector('.flip_card_inner');
    if (!inner) return;

    gsap.set(inner, { rotationY: 0 });

    const flip = (deg) => gsap.to(inner, { rotationY: deg, duration: 0.7, ease: 'power2.inOut' });

    if (flipCardsCanHover) {
        card.addEventListener('mouseenter', () => flip(180));
        card.addEventListener('mouseleave', () => flip(0));
    } else {
        card.addEventListener('click', () => {
            const flipped = card.classList.toggle('is-flipped');
            flip(flipped ? 180 : 0);
        });
    }
});




document.fonts.ready.then(() => {

  document.querySelectorAll(".split").forEach((el) => {
    const split = SplitText.create(el, {
      type: "words,lines",
      linesClass: "line",
      autoSplit: true,
      mask: "lines",
    });

    gsap.from(split.lines, {
      scrollTrigger: {
        trigger: el,
        start: "top 70%",
        toggleActions: "play none none none",
      },
      duration: 2,
      yPercent: 100,
      opacity: 0,
      stagger: 0.2,
      ease: "expo.out",
    });
  });


    document.querySelectorAll(".swiper:not(.slider_expertise_interno, .slider_expertise)").forEach((el) => {
        const slides = el.querySelectorAll(".swiper-slide");
        gsap.from(slides, {
            scrollTrigger: {
                trigger: el,
                start: "top 80%",
                toggleActions: "play none none none",
            },
            duration: 1.5,
            yPercent: 20,
            opacity: 0,
            stagger: 0.2,
            ease: "expo.out",
        });
    });
  

    if(window.innerWidth > 990) {
        document.querySelectorAll(".masonry_item").forEach((el) => {
            gsap.from(el, {
                scrollTrigger: {
                    trigger: el,
                    start: "top 80%",
                    toggleActions: "play none none none",
                },
                duration: 1.5,
                yPercent: 20,
                opacity: 0,
                stagger: 0.2,
                ease: "expo.out",
            });
        });
    }
    
    document.querySelectorAll("hr.wp-block-separator").forEach((el) => {
        gsap.from(el, {
            scrollTrigger: {
                trigger: el,
                start: "top 70%",
                toggleActions: "play none none none",
            },
            duration: 2,
            width: 0,
            ease: "expo.out",
        });
    });


})

const scrollerTimeline = document.querySelector(".timeline");
// Calcolo dinamico della distanza da scrollare
const updateScroll = () => {

    if(!scrollerTimeline) return false
    const scrollWidth = scrollerTimeline.scrollWidth;
    const viewportWidth = window.innerWidth;
    const scrollDistance = scrollWidth - viewportWidth;

    ScrollTrigger.getAll().forEach(t => t.kill()); // reset in caso di resize

    const timelineAnimation = gsap.to(scrollerTimeline, {
        x: -scrollDistance,
        ease: "none",
        scrollTrigger: {
            trigger: ".timeline_block",
            start: "center center",
            end: `+=${scrollDistance}`,
            scrub: 1,
            pin: true,
            anticipatePin: 1
        }
    });

    document.querySelectorAll(".punto").forEach((punto) => {
        ScrollTrigger.create({
            trigger: punto,
            start: "center center",
            containerAnimation: timelineAnimation,
            onEnter: () => punto.classList.add("active"),
            onLeave: () => punto.classList.remove("active"),
            onEnterBack: () => punto.classList.add("active"),
            onLeaveBack: () => punto.classList.remove("active")
        });
    });
};

if ($(window).width() > 990) {
    updateScroll();
    window.addEventListener("resize", updateScroll);
}
// var Isotope = require('isotope-layout');

import massimo from "./js/massimo";
massimo();

import navbar from "./js/navbar";
navbar();

import footer from "./js/footer";
footer();

import sidebar from "./js/sidebar";
sidebar();

import search from "./js/search";
search();

// import woocommerce from "./js/woocommerce";
// woocommerce();

import scrollTop from "./js/scrollTop";
scrollTop();

import formCf7Modal from "./js/form-cf7-modal";
formCf7Modal();
